<template>
	<div id="novel_list" style="overflow: auto;">
		<div class="novel_list_top">
			<div class="novel_list">
				<div class="flex-row">
					<div class="novel_list1 cursor_1" @click="toHome">
						<img src="../assets/image/icon_right.png" alt="">
						作品列表
					</div>
					<!-- <div class="t-m-l-20">
					<el-button type="text" class="novel_list2 " v-if="novelList.length > 0">
						<span @click="openEditor" v-if="isEdit">管理</span>
						<span @click="openEditor" v-if="!isEdit">取消</span>
					</el-button>
				</div> -->

				</div>
				<div class="flex-row" :class="!isEdit ? 'noEditor_pointer' : ''">
					<el-select class="search_select" v-model="status" clearable placeholder="连载状态" style="width:150px;"
						@change="statusSelectChange">
						<el-option label="选择连载状态" value=""></el-option>
						<el-option :label="`连载（${novelCount.serial}）`" value="0"></el-option>
						<el-option :label="`完结（${novelCount.done}）`" value="1"></el-option>
					</el-select>
					<el-select class="search_select t-m-l-15" v-model="length" clearable placeholder=""
						style="width: 150px;" @change="statusSelectChange">
						<el-option label="选择篇幅设定" value=''></el-option>
						<el-option :label="`长篇（${novelCount.lengthy}）`" value="长篇"></el-option>
						<el-option :label="`中篇（${novelCount.medium}）`" value="中长篇小说"></el-option>
						<el-option :label="`短篇（${novelCount.shortly}）`" value="短篇小说"></el-option>
					</el-select>
					<el-select class="search_select t-m-l-15" v-model="collect" clearable placeholder="是否收藏"
						style="width: 120px;" @change="statusSelectChange">
						<el-option label="是否收藏" value=''></el-option>
						<el-option :label="`已收藏（${novelCount.collect}）`" :value=true></el-option>
						<!-- <el-option label="未收藏" :value=false></el-option> -->
					</el-select>
					<!-- <el-radio-group v-model="status" class="t-m-r-20" style="display: flex;user-select: none;"
					@input="statusChang">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="0">连载</el-radio-button>
					<el-radio-button label="1">完结</el-radio-button>
				</el-radio-group>
				<el-radio-group v-model="length" class="t-m-r-20" style="display: flex;user-select: none;"
					@input="lengthChang">
					<el-radio-button label="长篇">长篇</el-radio-button>
					<el-radio-button label="中篇">中篇</el-radio-button>
					<el-radio-button label="短篇">短篇</el-radio-button>
				</el-radio-group> -->
					<el-input placeholder="请输入作品名称" v-model="query" class="novel_input-with-select t-m-l-15 t-m-r-20"
						@keyup.enter.native="selectClick" @input="blurClick">
						<i class="el-icon-search el-input__icon cursor_1"
							:style="{ pointerEvents: !isEdit ? 'none' : '' }" slot="suffix" @click="selectClick">
						</i>
					</el-input>
					<el-button type="primary" @click="toCreate('add')" class="novel_list2">
						<span class="el-icon-plus" style="font-weight: bold;"></span>
						<span>创建新作品</span>
					</el-button>
					<!-- <div class="novel_list2 cursor_1 shrink-0 t-m-l-20" >

				</div>
				<div class="novel_list2 cursor_1 shrink-0 t-m-l-20" @click="toCreate">
					管理
				</div> -->
				</div>

			</div>
			<div class="novel_list3" v-if="!searchResult">
				<!-- <el-empty description="未搜索到相关作品"></el-empty> -->
				<img src="@/assets/image/home/xs_empty.png"
					style="object-fit: cover;height: 100%;width: 100%;cursor: pointer;" @click="toCreate('add')" />
			</div>

			<div class="novel_list3" v-else>
				<div v-if="!isEdit" class="selectBtn">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
						@change="handleCheckAllChange">全选</el-checkbox>
					<el-button type="text" @click="batchDel" style="margin-left: 20px;">删除</el-button>
				</div>
				<div class="item">
					<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
						<div class="novel_list4" v-for="(item, i) in novelList" :key="item.id"
							@click.stop="nextStep(i, 1)">
							<el-checkbox :label="item.id" v-if="!isEdit" class="no-label"></el-checkbox>
							<div
								style="position: relative;width: 100px;height: 133px;flex-shrink: 0;border-radius: 8px;">
								<img class="novel_list5" style="object-fit: cover;" :src="item.img" alt=""
									@click.stop="nextStep(i, 1)">
								<span class="length_text zhong"
									v-if="item.length && item.length.includes('中')">中篇</span>
								<span class="length_text duan"
									v-else-if="item.length && item.length.includes('短')">短篇</span>
								<span class="length_text long"
									v-else-if="item.length && item.length.includes('长')">长篇</span>
							</div>

							<div class="novel_list6">
								<div class="novel_list7">{{ item.name }}</div>
								<div class="novel_list8">
									<span style="margin-right: 10px;">{{ item.status == 0 ? '连载中' : '已完结' }} {{
										item.totalNumber }}</span>
								</div>
								<div class="novel_list8">{{ item.chapters }}</div>
								<div class="novel_list9">
									<div class="novel_list10">{{ item.lastUpdate }}<span
											class="t-m-l-20 novel_time_text" v-if="item.lastUpdateTime">{{
												item.lastUpdateTime
											}}更新</span></div>
									<div class="novel_list11 noBorderArray">
										<div class="novel_list12 cursor_1 btn_item" @click.stop="nextStep(i, 11)">
											<img class="t-m-r-5" :src="item.collect ? collectIcon[0] : collectIcon[1]"
												alt="" />
											<span :class="item.collect ? 'sc' : ''">收藏</span>
										</div>

										<template v-for="(items, l) in novelListIcon">
											<el-tooltip popper-class="novel_toolTip"
												:disabled="Object.hasOwn(items, 'title') ? false : true" :key="l"
												placement="top" effect="light" :content="tooltipName(item, items)">
												<div class="novel_list12 cursor_1 btn_item" @click.stop="nextStep(i, l)"
													@mouseenter="() => { selectedIndex = l; selectedId = item.id }"
													@mouseleave="() => { selectedIndex = -1; selectedId = '' }">
													<img class="t-m-r-5" v-if="items.name == '置顶'"
														:src="selectedIndex === l && selectedId == item.id || item.top > 0 ? items.icon : items.uIcon"
														alt="">
													<img class="t-m-r-5" v-else
														:src="selectedIndex === l && selectedId == item.id ? items.icon : items.uIcon"
														alt="">
													<span v-if="items.name == '置顶'" :class="item.top > 0 ? 'sc' : ''">{{
														item.top > 0 ? '已置顶' : items.name
													}}</span>
													<span v-else>{{ items.name }}</span>
												</div>
											</el-tooltip>
										</template>

									</div>
								</div>
							</div>
						</div>
					</el-checkbox-group>
				</div>
			</div>
		</div>
		<bottomPage v-show="total" :total="total" @currentNUm="currentNUm" :pageSize="this.pageSize" ref="bottompage">
		</bottomPage>
		<delPopup ref="delPopup" @confirm="confirmDel"></delPopup>
		<LengthSettingPopup ref="lengthSetting" @curClick="curClick"></LengthSettingPopup>
	</div>
</template>

<script>
import data from '@/assets/data';
import noData from './no_data.vue';
import delPopup from './del_popup.vue';
import LengthSettingPopup from '@/components/long_novel/LengthSettingPopup.vue';
import bottomPage from '../components/bottom_page.vue' //底部分页
import api from '@/api/api';
import lNApi from '@/api/longNovel'
import { EncryptionUtil } from '@/utils/encrypt'
export default {
	components: {
		noData, delPopup, LengthSettingPopup, bottomPage
	},
	props: {
		novelList: {
			type: Array,
			default: []
		},
		total: {
			type: Number,
			default: 0
		}
	},
	watch: {
		novelList: {
			// 处理函数
			handler(newVal, oldVal) {
				console.log('newVal=', newVal)
				if (newVal && Object.keys(newVal).length > 0) {
					this.searchResult = true
				} else {
					this.searchResult = false
				}
			},
			deep: true,      // 深度监听（对象内部属性变化）
		}
	},
	// computed: {
	// 	searchResult() {
	// 		return this.novelList && Object.keys(this.novelList).length > 0 ? true : false
	// 	}
	// },
	data() {
		return {
			novelListIcon: data.novelListIcon,//作品编辑
			collectIcon: data.collectIcon,//收藏图标
			delId: null, //删除id
			query: '',//搜索关键字
			status: '',// 空是全部，连载状态(0连载中 1已完结)
			collect: '',//是否收藏
			length: '',//篇幅设定
			pageNum: 1,
			pageSize: 20,
			searchResult: true,
			isEdit: true,//默认true不编辑，true编辑
			checkAll: false,
			checkedCount: 0,//选中状态
			checkedCities: [],
			isIndeterminate: false,
			novelCount: {
				"total": 0,
				"collect": 0,
				"serial": 0,
				"done": 0,
				"lengthy": 0,
				"medium": 0,
				"shortly": 0
			}
		}
	},
	created() {
		let cache = JSON.parse(localStorage.getItem(this.nSearchKey))
		console.log('获取本地缓存=', cache)
		Object.assign(this.$data, cache)
	},
	mounted() {
		console.log('请求统计数=')
		this.novelCounts()
		if (this.$refs.bottompage) {
			setTimeout(() => {
				this.$refs.bottompage.page(this.pageNum)
			}, 200);
		}

	},
	// watch: {
	// 	query: {
	// 		handler(newVal) {
	// 			this.blurClick()
	// 		},
	// 		immediate: false
	// 	}
	// },

	methods: {
		novelCounts() {
			api.novelCount().then(res => {
				if (res.code === 200) {
					this.novelCount = res.data
				}
			})
		},
		tooltipName(item, items) {
			// console.log('过滤器=', item);
			let name = ''
			if (items.name === '编辑') {
				name = item.length.startsWith("长篇") ? '编辑分卷' : '编辑大纲'
			}
			else if (items.name === '管理') {
				name = item.length.startsWith("长篇") ? '分卷管理' : '章节管理'
			}
			else if (items.name === '置顶') {
				name = item.top > 0 ? '已置顶' : '置顶'
			} else {
				name = items.title
			}
			return name
		},
		//搜索
		selectClick(pageInit) {
			let data = { query: this.query, status: this.status, length: this.length, collect: this.collect, pageNum: this.pageNum, pageSize: this.pageSize }
			//加入到缓存
			if (pageInit) {
				data.pageNum = 1
			}
			localStorage.setItem(this.nSearchKey, JSON.stringify(data))
			this.$emit('search', data)
		},
		//失去焦点触发
		blurClick() {
			if (!this.query.trim()) {
				this.selectClick(true)
			}
		},
		statusSelectChange(e) {
			this.selectClick(true)
		},
		lengthSelectChange(e) {
			this.selectClick(true)
		},
		//状态选择
		statusChang(e) {
			console.log('状态值选中=', e)
			this.selectClick(true)
		},
		lengthChang() {
			this.selectClick(true)
		},
		toHome() {
			this.$router.push({ path: '/' });
		},
		//去创作
		toCreate(type, novelId = '') {
			this.$refs.lengthSetting.open(type, novelId)
			// this.$emit('toCreate')
		},
		//小说的行为，去新建还是克隆，还是编辑
		curClick(params) {
			if (params.item.length.includes('中') || params.item.length.includes('短')) {
				params.item.length = params.item.length.includes('中') ? '中长篇小说' : '短篇小说'
				this.$emit('toCreate', params.item)
			} else {
				if (params.type === 'add') {
					this.$router.push('/longNovel');
				}
			}
		},
		//批量删除
		batchDel() {
			if (!this.checkedCities.length) {
				this.$message.warning('请选择要删除的作品')
				return
			}
			this.$refs.delPopup.openPrompt(0, true)
		},
		//0作品置顶 1章节管理 2查看大纲 3作品信息 4作品下载 5作品克隆 6作品删除
		nextStep(i, l) {
			//作品收藏、取消收藏
			if (l == 11) {
				let type = this.novelList[i].ltype === 'lnovel' ? 'lnovel' : 'novel'
				let apiName = this.novelList[i].collect ? 'novelCancelCollect' : 'novelAddCollect'
				api[apiName]({ novelId: this.novelList[i].id, type }).then(res => {
					if (res.code === 200) {
						this.$message.success(apiName.includes('Add') ? '收藏成功！' : '已取消收藏！')
						// this.novelList[i].collect = apiName.includes('Add') ? true : false
						this.selectClick()
						setTimeout(() => {
							this.novelCounts()
						}, 20);

					} else {
						this.$message.warning(res.msg)
					}
				})
				return
			}
			//作品置顶
			if (l == 0) {
				//取消置顶
				if (this.novelList[i].top > 0) {
					api.untop({ novelId: this.novelList[i].id, type: this.novelList[i].ltype }).then(res => {
						if (res.code === 200) {
							this.$message.success('小说已取消置顶！')
							this.selectClick()
						} else {
							this.$message.warning(res.msg)
						}
					})
				} else {
					if (this.novelList[i].ltype === 'lnovel') {
						lNApi.longNovelTop({ id: this.novelList[i].id }).then(res => {
							if (res.code === 200) {
								this.$message.success('小说置顶成功！')
								this.selectClick()
							} else {
								this.$message.warning(res.msg)
							}
						})
					} else {
						api.novelTop({ novelId: this.novelList[i].id }).then(res => {
							if (res.code === 200) {
								this.$message.success('小说置顶成功！')
								this.selectClick()
							}
						})
					}
				}
				return
			}
			//克隆
			if (l == 5) {
				if (this.novelList[i].ltype === 'lnovel') {
					this.$router.push({ path: '/longNovelEdit', query: { copy: true, successNovelId: this.novelList[i].id } });
				} else {
					this.$emit('copyNovel', this.novelList[i]);
				}
				return
			}
			//删除
			if (l == 6) {
				// this.$refs.delPopup.openPrompt(0)
				this.$confirm('确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delId = i
					if (this.novelList[i].ltype === 'lnovel') {
						lNApi.longNovelDel({ id: this.novelList[i].id }).then((res) => {
							if (res.code == 200) {
								this.$message.success('删除成功！')
								// this.novelList.splice(this.delId, 1)
								this.selectClick()
								setTimeout(() => {
									this.novelCounts()
								}, 20);
							}
						})
					} else {
						api.delNovel({ ids: this.novelList[i].id }).then((res) => {
							if (res.code == 200) {
								this.$message.success('删除成功！')
								// this.novelList.splice(this.delId, 1)
								this.selectClick()
								setTimeout(() => {
									this.novelCounts()
								}, 20);
							}
						})
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				return
			}
			// 有大纲就走这里
			if (this.novelList[i].thereAnOutline) {
				//作品下载
				if (l == 4) {
					if (this.novelList[i].ltype === 'lnovel') {
						lNApi.longNovelDownload({ novelId: this.novelList[i].id }).then((res) => {
							let downloadInfo = this.saveTextToFile(res, this.novelList[i])
							this.saveToLocalStorage(downloadInfo)
						})
					} else {
						api.downloadText({ novelId: this.novelList[i].id }).then((res) => {
							let downloadInfo = this.saveTextToFile(res, this.novelList[i])
							this.saveToLocalStorage(downloadInfo)
						})
					}

				} else if (l == 2) {
					//编辑大纲
					let editItem = {
						id: this.novelList[i].id,
						novelInfo: this.novelList[i],
						editType: 3,
						backNum: 1,
					}
					//编辑大纲 加入到缓存
					sessionStorage.setItem('editItem', JSON.stringify(editItem))
					if (this.novelList[i].ltype === 'lnovel') {
						this.$router.push({ path: '/seriesEditor' })
					} else {
						this.$router.push({ path: '/editor' });
					}
				} else {
					//1,3
					if (this.novelList[i].ltype === 'lnovel') {
						if (l == 1) {
							this.$router.push({ path: '/seriesList', query: { novelInfo: EncryptionUtil.encrypt(this.novelList[i]), successNovelId: this.novelList[i].id } })
						} else if (l == 3) {
							// this.toCreate('edit',this.novelList[i].id)
							this.$router.push({ path: '/longNovelEdit', query: { copy: false, successNovelId: this.novelList[i].id } });
							// this.$router.push({ path: '/seriesInfo', query: { successNovelId: this.novelList[i].id } })
						}

					} else {
						//查看章节的时候清空章节列表的搜索记录
						if (l == 1) {
							let key = this.getChapterSearchKey(this.nChapterSearchKey, this.novelList[i].id)
							localStorage.removeItem(key);
						}

						this.$emit('nextStep', l, this.novelList[i]);
					}

				}
			}
			//没有章纲走其他地方
			else {
				if (this.novelList[i].ltype === 'lnovel') {
					this.$router.push({ path: '/seriesSuccess', query: { type: 'series', novelInfo: EncryptionUtil.encrypt(this.novelList[i]), successNovelId: this.novelList[i].id } })
				} else {
					this.$emit('nextStep', 4, this.novelList[i]);
				}
			}

		},
		saveTextToFile(text, novel) {
			const now = new Date();
			const timestamp = now.toISOString().replace(/[:.]/g, '-');
			const fileName = `${novel.name}_${timestamp}.txt`;
			const element = document.createElement('a');
			const file = new Blob([text], { type: 'text/plain' });
			element.href = URL.createObjectURL(file);
			element.download = fileName;
			element.click();
			URL.revokeObjectURL(element.href);
			return {
				fileName,
				downloadTime: now.toISOString(),
			};
		},
		saveToLocalStorage(downloadInfo) {
			let novelDownload = JSON.parse(localStorage.getItem('novelDownload')) || [];
			novelDownload.push(downloadInfo);
			localStorage.setItem('novelDownload', JSON.stringify(novelDownload));
		},
		//数据初始化
		initData() {
			this.isEdit = true
			this.checkedCities = []
			this.checkAll = false
			this.indeterminate = false
			this.checkedCount = 0
		},
		//确认删除
		confirmDel(isAllDel) {
			if (isAllDel) {
				console.log(this.checkedCities.join(','))
				api.delNovel({ ids: this.checkedCities.join(',') }).then((res) => {
					if (res.code == 200) {
						this.$message.success('删除成功！')
						this.initData()
						this.$emit('search', { query: this.query, status: this.status })
					}
				})
			} else {
				api.delNovel({ ids: this.novelList[this.delId].id }).then((res) => {
					if (res.code == 200) {
						this.$message.success('删除成功！')
						this.novelList.splice(this.delId, 1)
					}
				})
			}

		},
		openEditor() {
			this.isEdit = !this.isEdit
			//如果取消，就取消勾选
			if (this.isEdit) {
				this.initData()
			}
		},
		handleCheckAllChange(val) {
			this.checkedCities = val ? this.novelList.map(item => item.id) : [];
			this.isIndeterminate = false;
			// console.log('全选事件=', val)
		},
		handleCheckedCitiesChange(value) {
			this.checkedCount = value.length;
			this.checkAll = this.checkedCount === this.novelList.length;
			this.isIndeterminate = this.checkedCount > 0 && checkedCount < this.novelList.length;
			// console.log('选中事件=', value)
		},
		//分页下一页
		currentNUm(pageNum) {
			this.pageNum = pageNum
			//分页记录缓存
			this.selectClick()
		},
	}
}
</script>

<style lang="scss" scoped>
.novel_input-with-select {
	width: 300px;
	background-color: #FFFFFF !important;

	::v-deep(.el-input__inner) {
		width: 100% !important;
		background-color: #FFFFFF !important;

		&::placeholder {
			color: #aaa;
		}
	}
}

.search_select {

	::v-deep(.el-input__inner) {
		width: 100% !important;
		background-color: #FFFFFF !important;

		&::placeholder {
			color: #aaa;
		}
	}
}

.novel_input-with-select .el-icon-search {
	font-size: 120% !important;
}

.novel_input-with-select>.el-input__inner {
	background-color: #FFFFFF !important;
	width: 300px !important;
}

#novel_list {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

}

.novel_list_top {
	border-radius: 10px;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: #FFFFFF;
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	overflow: auto;
	margin-bottom: 15px;
}

.novel_list {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	height: 77px;
	justify-content: space-between;
	border-bottom: 1px solid #E6EBF0;
	padding: 0 25px;
}

.novel_list1 {
	font-weight: bold;
	font-size: 19px;
	color: #111111;
	display: flex;
	align-items: center;
	flex-shrink: 0;
}

.novel_list1 img {
	width: 23px;
	height: 23px;
	margin-right: 5px;
}

.no-label {
	padding-right: 20px !important;

	::v-deep .el-checkbox__label {
		display: none !important;
	}
}



/* .novel_list2 {
	width: 110px;
	height: 21px;
	background: url('../assets/image/icon_list.png') no-repeat;
	background-size: 21px 21px;
	background-position: left center;
	padding-left: 25px;
	font-size: 17px;
	color: var(--tech-primary);
	line-height: 21px;
} */

.novel_list2 {
	height: 40px;

	span {
		font-size: 17px;
	}
}

/* .novel_list2:hover {
	background: url('../assets/image/icon_list1.png') no-repeat;
	background-size: 21px 21px;
	color: var(--tech-primary);
} */

.novel_list3 {
	flex: 1;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
}

.novel_list3 .selectBtn {
	flex-shrink: 0;
	height: 50px;
	line-height: 50px;
	padding: 0 25px;
}

.novel_list3 .item {
	flex: 1;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	-ms-overflow-style: none;
	scrollbar-width: none;
}

.novel_list4 {
	display: flex;
	margin: 0 25px;
	padding: 21px 0;
	border-bottom: 1px solid #E6EBF0;
}

.novel_list5 {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 8px;
	flex-shrink: 0;
}

.length_text {
	position: absolute;
	display: block;
	font-size: 15px;
	text-align: center;
	top: 0;
	left: 0;
	width: 40px;
	/* 长方形的宽度 */
	height: 24px;
	/* 形状颜色 */
	border-top-left-radius: 6px;
	/* 左上角与父 div 圆角一致 */
	border-bottom-right-radius: 12px;
	/* 右侧弧度 */

	&.long {
		background: #FF6603;
		color: #fff;
	}

	&.duan {
		background: #00CF9B;
		color: #fff;
	}

	&.zhong {
		background: #548AFF;
		color: #fff;
	}
}

.novel_list6 {
	flex: 1;
	height: 133px;
	margin-left: 10px;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.novel_list7 {
	font-weight: bold;
	font-size: 18px;
	color: #111111;
}

.novel_list8 {
	font-size: 16px;
	color: #333333;
}

.novel_list9 {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.novel_time_text {
	color: var(--tech-primary);
}

.novel_list10 {
	font-size: 14px;
	color: #666666;
}

.novel_list11 {
	display: grid;
	grid-template-columns: repeat(8, 1fr);
	align-items: center;
	width: 45rem !important;
}

.novel_list12 {
	display: flex;
	align-items: center;
	font-size: 15px;
	color: #333333;

	.sc {
		color: var(--tech-primary);
	}
}

.novel_list12:hover {
	color: var(--tech-primary);
}
</style>